import { useCallback, useEffect, useState } from "react";
import { pln } from "@/lib/api";

const KEY = "empro_cart";
const EVT = "empro-cart-changed";

export const zl = (grosz) => pln((grosz || 0) / 100);

export const readCart = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const writeCart = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event(EVT));
};

const sameLine = (a, b) => a.product_id === b.product_id && a.color === b.color && a.size === b.size;

export function useCart() {
  const [items, setItems] = useState(readCart());
  useEffect(() => {
    const sync = () => setItems(readCart());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);

  const add = useCallback((line) => {
    const cur = readCart();
    const idx = cur.findIndex((x) => sameLine(x, line));
    if (idx >= 0) cur[idx].quantity += line.quantity;
    else cur.push(line);
    writeCart(cur);
  }, []);

  const update = useCallback((i, qty) => {
    const cur = readCart();
    if (!cur[i]) return;
    cur[i].quantity = Math.max(1, qty);
    writeCart(cur);
  }, []);

  const remove = useCallback((i) => {
    const cur = readCart();
    cur.splice(i, 1);
    writeCart(cur);
  }, []);

  const clear = useCallback(() => writeCart([]), []);

  const count = items.reduce((s, x) => s + x.quantity, 0);
  const subtotal = items.reduce((s, x) => s + x.price_grosz * x.quantity, 0);
  return { items, count, subtotal, add, update, remove, clear };
}
